import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { V4ThemeProvider } from './theme';
import { RequireAuth }     from './shell';
import NavBar          from './components/NavBar';


/* Subtle particle background */
const BG_CSS = `
@keyframes v4ParticleDrift {
  0%   { transform:translateY(0)   translateX(0)  opacity:0.5; }
  50%  { transform:translateY(-80px) translateX(15px); opacity:0.2; }
  100% { transform:translateY(-160px) translateX(-8px); opacity:0; }
}
.v4-particle {
  position:fixed; width:3px; height:3px; border-radius:50%;
  background:rgba(var(--v4-cyan-rgb),0.4);
  animation:v4ParticleDrift linear infinite;
  pointer-events:none; z-index:0;
}
.v4-particle-layer { opacity:var(--v4-glow-k); }
`;

const PARTICLES = [
  {left:'8%',  top:'85%', animDuration:'9s',  animDelay:'0s'   },
  {left:'18%', top:'70%', animDuration:'7s',  animDelay:'2s'   },
  {left:'35%', top:'90%', animDuration:'11s', animDelay:'1s'   },
  {left:'52%', top:'78%', animDuration:'8s',  animDelay:'3.5s' },
  {left:'68%', top:'88%', animDuration:'10s', animDelay:'0.8s' },
  {left:'80%', top:'75%', animDuration:'6.5s',animDelay:'2.5s' },
  {left:'92%', top:'82%', animDuration:'9.5s',animDelay:'1.5s' },
  {left:'25%', top:'92%', animDuration:'7.5s',animDelay:'4s'   },
];

export default function V4Layout() {
  return (
    <V4ThemeProvider>
    <RequireAuth>
      <style>{BG_CSS}</style>

      {/* Ambient glow blobs */}
      <Box sx={{ position:'fixed', inset:0, zIndex:0, pointerEvents:'none', overflow:'hidden', opacity:'var(--v4-glow-k)' }}>
        <Box sx={{ position:'absolute', top:'-10%', left:'-5%', width:500, height:500, borderRadius:'50%', background:'radial-gradient(circle,rgba(var(--v4-cyan-rgb),0.06) 0%,transparent 70%)', filter:'blur(40px)' }} />
        <Box sx={{ position:'absolute', bottom:'-15%', right:'-8%', width:600, height:600, borderRadius:'50%', background:'radial-gradient(circle,rgba(var(--v4-green-rgb),0.04) 0%,transparent 70%)', filter:'blur(60px)' }} />
        <Box sx={{ position:'absolute', top:'40%', right:'20%', width:300, height:300, borderRadius:'50%', background:'radial-gradient(circle,rgba(var(--v4-purple-rgb),0.04) 0%,transparent 70%)', filter:'blur(50px)' }} />
      </Box>

      {/* Particles */}
      <div className="v4-particle-layer">
        {PARTICLES.map((p, i) => (
          <div key={i} className="v4-particle" style={{ left:p.left, top:p.top, animationDuration:p.animDuration, animationDelay:p.animDelay }} />
        ))}
      </div>

      <Box sx={{ display:'flex', flexDirection:'column', height:'100vh', overflow:'hidden', position:'relative', zIndex:1 }}>
        <NavBar />
        <Box sx={{
          flex:1, overflowY:'auto', overflowX:'hidden',
          px:{ xs:2, sm:3, md:4 }, py:3,
          scrollbarWidth:'thin', scrollbarColor:'rgba(var(--v4-cyan-rgb),0.2) transparent',
          '&::-webkit-scrollbar':{ width:5 },
          '&::-webkit-scrollbar-track':{ background:'transparent' },
          '&::-webkit-scrollbar-thumb':{ background:'rgba(var(--v4-cyan-rgb),0.2)', borderRadius:3 },
        }}>
          <Outlet />
        </Box>
      </Box>
    </RequireAuth>
    </V4ThemeProvider>
  );
}
